<template>
  <components
    :is="cmptData.cmpt"
    plain
    :class="cmptData.class"
    @click="$emit('click')"
  >
    {{ $t('pc_biz_core_btn_cancel') }}
  </components>
</template>

<script>
import { Button, FrontButton } from 'yxt-pc';
export default {
  name: '',
  inject: ['isBack'],
  data() {
    return {};
  },
  computed: {
    cmptData() {
      return this.isBack ? { cmpt: Button, class: 'mr16' } : { cmpt: FrontButton };
    }
  },
  methods: {}
};
</script>
